import { api } from "./configs/axiosConfigs"

export const priceListBranchOfficeAPI = {
    
    getPriceListBranchoffice: async (data:any) => {
        const response = await api.get(
            '/priceListBranchOffice', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createPriceListBranchoffice: async (data: any) => {
        const response = await api.post(
            '/priceListBranchOffice/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editPriceListBranchoffice: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/priceListBranchOffice/${idlist}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    deletePriceListBranchoffice: async (idlist: number) => {
        const response = await api.delete(
            `/priceListBranchOffice/${idlist}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}